<template>
  <OnBoardingFrame
    as-form
    back
    :step="3"
    :title="$t('on_boarding.profile_name_page.title')"
    :subtitle="$t('on_boarding.profile_name_page.subtitle')"
    :error="errorMessage"
    @back="backTapped"
    @submit="submit"
  >
    <!-- Step 3 of the post-signup profile wizard. Mirrors the mobile Name screen
         (iOS OnBoardingNameViewController / Android OnboardingNameFragment),
         which collects first and last name as separate fields. Back returns to
         the profile picture. -->
    <div class="ob-fields">
      <div class="ob-field">
        <label class="ob-label" for="profileFirstName">
          {{ $t('on_boarding.profile_name_page.first_name_placeholder') }}
        </label>
        <input
          id="profileFirstName"
          ref="firstNameInput"
          v-model="firstName"
          type="text"
          class="ob-input"
          :placeholder="$t('on_boarding.profile_name_page.first_name_placeholder')"
          autocomplete="given-name"
          required
        >
      </div>

      <div class="ob-field">
        <label class="ob-label" for="profileLastName">
          {{ $t('on_boarding.profile_name_page.last_name_placeholder') }}
        </label>
        <input
          id="profileLastName"
          v-model="lastName"
          type="text"
          class="ob-input"
          :placeholder="$t('on_boarding.profile_name_page.last_name_placeholder')"
          autocomplete="family-name"
          required
        >
      </div>
    </div>

    <template #footer>
      <button type="submit" class="ob-btn ob-btn-primary" :disabled="!canSubmit">
        {{ $t('on_boarding.profile_name_page.continue') }}
      </button>
    </template>
  </OnBoardingFrame>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import OnBoardingFrame from './OnBoardingFrame.vue';
import { isValidNameParts } from '../../../utils/helpers/signupProfile';

export default defineComponent({
  name: 'OnBoardingProfileNamePage',
  components: { OnBoardingFrame },
  data() {
    return {
      // Seeded from the store, which prefills from the Rails record or the
      // identity provider — an SSO user usually only has to confirm.
      firstName: this.$store.state.onBoarding.profileFirstName || '',
      lastName: this.$store.state.onBoarding.profileLastName || '',
    };
  },
  computed: {
    errorMessage(): string | null {
      return this.$store.state.onBoarding.errorMessage;
    },
    canSubmit(): boolean {
      return isValidNameParts({ firstName: this.firstName, lastName: this.lastName });
    },
  },
  mounted() {
    (this.$refs.firstNameInput as HTMLInputElement | undefined)?.focus();
  },
  methods: {
    submit() {
      if (!this.canSubmit) {
        this.$store.commit('onBoarding/setError', this.$t('on_boarding.profile_name_page.error_missing'));
        return;
      }
      this.$store.dispatch('onBoarding/submitProfileName', {
        firstName: this.firstName.trim(),
        lastName: this.lastName.trim(),
      });
    },
    backTapped() {
      this.$store.commit('onBoarding/setError', null);
      this.$store.commit('onBoarding/popPage');
    },
  },
  beforeUnmount() {
    this.$store.commit('onBoarding/setError', null);
  },
});
</script>
